import {
  PARENT_CATEGORY_LIST,
  ADD_CHECKLISTS,
  ADD_CATEGORY,
  CHECK_LIST_ITEMS,
  UPDATE_CHECKLISTS,
  CHECKLIST_DELETE,
  CHECK_LIST,
  DELETE_CATEGORY,
  CHECKLIST_CAT_UPDATE,
  GET_CAT_BY_ID,
  NOT_FOUND,
} from "./type";
import { APIURL } from "./config";
import { toast } from "react-toastify";
import axios from "axios";

// backend data
export const ManageCheckLists = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/checkListCat`, config);
    dispatch({
      type: PARENT_CATEGORY_LIST,
      payload: res?.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
// front Data
export const CheckItems = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(
      `${APIURL}/api/v1/checklist/staff-checklist/${id}`,
      config
    );
    dispatch({
      type: CHECK_LIST,
      payload: res?.data,
    });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
// backend data

export const addCheckLists = (data) => async (dispatch) => {
  console.log(data, "data");
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(
      `${APIURL}/api/v1/checkListItem`,
      data,
      config
    );
    dispatch({ type: ADD_CHECKLISTS, payload: res.data });
    toast.success("CheckList Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-checklists");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
// backend data
export const CheckListItems = () => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.get(`${APIURL}/api/v1/checkListItem`, config);
    dispatch({
      type: CHECK_LIST_ITEMS,
      payload: res?.data,
    });
    if (res?.data?.data?.checklistchild?.length === 0) {
      dispatch({
        type: NOT_FOUND,
        payload: "",
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
// backend data

export const UpdateCheckLists = (data, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.patch(
      `${APIURL}/api/v1/checkListItem/${id}`,
      data,
      config
    );
    dispatch({
      type: UPDATE_CHECKLISTS,
      payload: res?.data,
    });
    toast.success("CheckList Created Successfully!");
    setTimeout(() => {
      return (window.location.href = "/manage-checklists");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
// backend data

export const CheckListsDelete = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete this checklist item?")) {
      const res = await axios.delete(
        `${APIURL}/api/v1/checkListItem/${id}`,
        config
      );
      toast.success("Checklist Item Deleted Successfully!");
      setTimeout(() => {
        return (window.location.href = "/manage-checklists");
      }, 1000);
      dispatch({
        type: CHECKLIST_DELETE,
        payload: res?.data,
      });
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const multiCheckListDelete = (id) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow",
  };
  const label = id?.length > 1 ? "Checklist Items" : "Checklist Item";
  if (window.confirm(`Do you want to delete the selected ${label.toLowerCase()}?`)) {
    fetch(`${APIURL}/api/v1/checklistitem/delete/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == "success") {
          toast.success(`${label} Deleted Successfully!`);
        }
      })
      .catch((error) => console.log("error", error));
  }
};

export const AddNewCategory = (data, callBack) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(`${APIURL}/api/v1/checkListCat`, data, config);
    dispatch({ type: ADD_CATEGORY, payload: res.data });
    callBack();
    toast.success("CheckList Category Created Successfully!");
  } catch (error) {
    toast.error(error?.response?.data?.message);
    callBack();
  }
};

export const DeleteCategory = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    if (window.confirm("Do you want to delete this category?")) {
      const res = await axios.delete(
        `${APIURL}/api/v1/checkListCat/${id}`,
        config
      );
      if (res) {
        toast.success("Category Deleted Successfully!");
        setTimeout(() => {
          dispatch({
            type: DELETE_CATEGORY,
          });
        }, 2000);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const updateManageCatList = (val, id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  var body = JSON.stringify({
    name: val.name,
    Detail: val.Detail,
    image: val.image == "undefined" ? "" : val.image,
  });

  try {
    const res = await axios.patch(
      `${APIURL}/api/v1/checkListCat/${id}`,
      body,
      config
    );
    dispatch({ type: CHECKLIST_CAT_UPDATE, payload: res.data });
    toast.success("CheckList Cat Updated Successfully!");
    setTimeout(() => {
      return (window.location.href = "/add-category");
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};

export const GetCatById = (id) => async (dispatch) => {
  const token = localStorage.getItem("token");
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);

  var requestOptions = {
    headers: myHeaders,
    redirect: "follow",
  };
  try {
    const res = await axios.get(
      `${APIURL}/api/v1/checkListCat/${id}`,
      requestOptions
    );
    dispatch({ type: GET_CAT_BY_ID, payload: res.data });
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
};
